import React from 'react';

export const InfoCircle = ({ width = 20, height = 20, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 5.00374C10.5523 5.00374 11 5.45146 11 6.00374V10.0037C11 10.556 10.5523 11.0037 10 11.0037C9.44771 11.0037 9 10.556 9 10.0037V6.00374C9 5.45146 9.44771 5.00374 10 5.00374Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 13.9963C9 13.444 9.44771 12.9963 10 12.9963H10.01C10.5623 12.9963 11.01 13.444 11.01 13.9963C11.01 14.5485 10.5623 14.9963 10.01 14.9963H10C9.44771 14.9963 9 14.5485 9 13.9963Z"
      fill="currentColor"
    />
  </svg>
);
